"use client"

import { Apartment } from "utils"
import ApartmentGallery from "../../../ApartmentsForRent/ApartmentGallery"

type Props = {
  apartment: Apartment
}

const ApartmentPlanFRM = ({ apartment }: Props) => {
  const drawings = apartment.apartmentsDrawing?.map((d) => d.drawing).filter(Boolean) || []
  if (drawings.length === 0) return null

  return (
    <ApartmentGallery
      apartment={{ ...apartment, gallery: [] }}
      imageGallery={{
        apartmentGallery: drawings,
        apartmentThumbnail: drawings[0] || "",
        numberOfRooms: Number(apartment.numberOfRooms) || undefined,
      }}
      height={"255px"}
      galleryDivRadius={"16px"}
      galleryDivBorder={"1px solid #E0E0E0"}
      fitContain
      useDrawer
    />
  )
}
export default ApartmentPlanFRM
